import React from 'react';
import './ShowroomSection.css';

const ShowroomSection = () => {
  const nftImages = [
    'nft1.webp',
    'nft2.webp',
    'nft3.webp',
    'nft4.webp',
    'nft5.webp',
    'nft6.webp',
    'nft7.webp',
    'nft8.webp',
    'nft9.webp',
  ];

  return (
    <section className="showroom-section">
      <h2 className="showroom-title">SHOWROOM</h2>
      <p className="mint-date">Minting December 16th on Kabila</p>
      <div className="showroom-track-container">
        <div className="showroom-track">
          {nftImages.concat(nftImages).map((image, index) => (
            <div key={index} className="nft-card">
              <img
                src={require(`../images/${image}`)}
                alt={`NFT ${index + 1}`}
                className="nft-image"
              />
            </div>
          ))}
        </div>
      </div>
      <a 
        href="https://market.kabila.app/collections/10126090/mint"
        target="_blank"
        rel="noopener noreferrer"
        className="mint-button"
      >
        Mint Now
      </a>
    </section>
  );
};

export default ShowroomSection;